import { IconButton, type IconButtonProps, styled } from "@mui/material";

export interface OrionIconButtonProps extends Omit<IconButtonProps, "variant"> {
  variant?: "standard" | "outlined";
}

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "variant",
})<{ variant?: "standard" | "outlined" }>(({ theme, variant }) => ({
  ...(variant === "outlined" && {
    border: `1px solid ${theme.palette.grey[800]}`,
    borderRadius: "8px",
    backgroundColor: "transparent",
    color: theme.palette.grey[800],
    // IconButton only transitions background-color by default, so this
    // component's custom border-color / color changes (hover + the
    // data-active pressed state) snapped instantly while every MuiButton in
    // the app eased. Match MUI's own easing/duration via the theme so the
    // outlined variant animates consistently at every call site.
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "color",
    ]),
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.grey[700],
    },
    "&.Mui-disabled": {
      border: `1px solid ${theme.palette.grey[300]}`,
      color: theme.palette.grey[400],
      backgroundColor: "transparent",
    },
    "&[data-active='true']": {
      backgroundColor: theme.palette.grey[800],
      borderColor: theme.palette.grey[800],
      color: theme.palette.getContrastText(theme.palette.grey[800]),
      "&:hover": {
        backgroundColor: theme.palette.grey[700],
        borderColor: theme.palette.grey[700],
      },
    },
  }),
}));

export const OrionIconButton = (props: OrionIconButtonProps) => {
  return <StyledIconButton {...props} />;
};
